import React from "react";
import AddProduct from "../../../components/screen/inventory/productActive/AddProduct";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";

const AddProductActive = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header="Tambah Produk"
        mainComponent={<AddProduct isWarehouse={isWarehouse} />}
        pageRole={isWarehouse ? 27 : 4}
      />
    </div>
  );
};

export default HOC(AddProductActive);
